import { cn } from '@heroui/react';

interface CounterProps {
  current: number;
  max?: number;
  isInvalid?: boolean;
  hasValue?: boolean;
}

export const Counter = ({ current, max, isInvalid, hasValue }: CounterProps) => {
  if (!max) {
    return null;
  }

  return (
    <div
      className={cn(
        'absolute bottom-2 right-3 text-xs pointer-events-none z-10 ps-1 rounded-lg',
        isInvalid ? 'text-danger' : 'text-base-20',
        hasValue && 'bg-base-60',
      )}
    >
      {current}/{max}
    </div>
  );
};
